export default function GradientDivider(){
    return (
        <>
        <div className="mt-3em">
        <div className="gradient small-height"></div>
        </div>
        </>
    );
}